export const content = {
  title: 'Manuell umplanen',
  apply: 'Übernehmen',
};
